var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcRoadmap1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "41px",
    viewBox: "0 0 45 41",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 7")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.3560115,3.93092308 L43.3717615,3.93473077 C44.3107385,4.20888462 44.9969885,5.07980769 45,6.11273077 L45,38.2666154 C45,39.3095769 44.16075,40.1548846 43.1249885,40.1548846 C42.94575,40.1548846 42.7717385,40.1299615 42.6202615,40.0853077 L29.403,36.3620769 L15.3997615,40.3338462 L1.63575,36.4018846 L1.62,36.3980769 C0.685488462,36.1211538 0.00301153846,35.2526538 0,34.2225 L0,2.06861538 C0,1.02565385 0.83925,0.180346154 1.87501154,0.180346154 C2.05726154,0.180346154 2.23348846,0.207 2.38648846,0.252346154 L15.4027385,3.97038462 L29.3999885,0 L43.3560115,3.93092308 Z M13.78125,36.7314231 L13.78125,6.64684615 L3.00001154,3.56711538 L3.00001154,33.6513462 L13.78125,36.7314231 Z M27.9014885,33.6492692 L27.9014885,3.56226923 L16.7812615,6.71711538 L16.7812615,36.8030769 L27.9014885,33.6492692 Z M41.9999885,36.7736538 L41.9999885,6.68596154 L30.9015,3.56019231 L30.9015,33.6475385 L41.9999885,36.7736538 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports-Final-with-actual-content",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Report-Landing",
    transform: "translate(-875.000000, -300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(238.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modules",
    transform: "translate(60.999988, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(552.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-865"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-864",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-17.3076923 -17.3076923 62.3076923 -17.3076923 62.3076923 57.6415385 -17.3076923 57.6415385"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcRoadmap1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_roadmap1.09b6f34d.svg";
export { ForwardRef as ReactComponent };